import EntityPermissionsMapperBinder from "logic/permissions/EntityPermissionsMapper";
const assertUnreachable = (type) => {
  throw new Error(`Can't find prefix for type: ${type != null ? type : "(undefined)"}`);
};
const getPermissionPrefixByType = (type, id) => EntityPermissionsMapperBinder.mapToPrefix(type, id) || assertUnreachable(type);
export default getPermissionPrefixByType;
